import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
} from 'react-router-dom';

import Admin from '../components/Admin';
import PrivateRoute from '../components/PrivateRoute';
import SignIn from '../components/SignIn';

// Redirect root-level react-admin routes to /app
const RedirectToApp = () => {
  const { pathname } = useLocation();
  return <Navigate to={`/app${pathname}`} replace />;
};

const routesConfig = createRoutesFromElements(
  <Route path="/">
    {/* Redirect from / to /app */}
    <Route index element={<Navigate to="/app" replace />} />
    <Route path="app">
      <Route path="login" element={<SignIn />} />
      {/* Layout route: PrivateRoute wraps all admin routes, stays mounted during navigation */}
      <Route
        element={
          <PrivateRoute>
            <Outlet />
          </PrivateRoute>
        }
      >
        {/* Index route for /app - renders Admin */}
        <Route index element={<Admin />} />
        {/* React-admin handles all routes under /app, including /app/Client, /app/User, etc. */}
        <Route path="*" element={<Admin />} />
      </Route>
    </Route>
    {/* Catch-all: redirect root-level react-admin routes (like /Client) to /app/Client */}
    <Route path="*" element={<RedirectToApp />} />
  </Route>,
);

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const browserRouter = sentryCreateBrowserRouter(routesConfig, {});
export const BrowserRouter = () => <RouterProvider router={browserRouter} />;
